import type { IconSvgObject } from './types';

const FileHeartIcon: IconSvgObject = [
  ["path", { d: "M4.5 11V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 22C7.5 22 3.5 19.5294 3.5 17.1389C3.5 15.9576 4.34211 15 5.5 15C6.1 15 6.7 15.2059 7.5 16.0294C8.3 15.2059 8.9 15 9.5 15C10.6579 15 11.5 15.9576 11.5 17.1389C11.5 19.5294 7.5 22 7.5 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileHeartIcon;
